import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './utils/api'
import VueI18n from 'vue-i18n'
import languages from './utils/languages'

Vue.use(VueI18n)

Vue.config.productionTip = false
Vue.api = Vue.prototype.$api = api;


//设置token和语言
const getUrlparam = (param) => {
  const reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg) || window.location.hash.substring((window.location.hash.search(/\?/)) + 1).match(reg);
  if (r != null) {
      return decodeURIComponent(r[2]);
  }
  return false;
};

const parseURL = (url) => {
    var a = document.createElement('a');
    a.href = url;
    return {
        source: url,
        protocol: a.protocol.replace(':',''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function(){
            var ret = {},
            seg = a.search.replace(/^\?/,'').split('&'),
            len = seg.length, i = 0, s;
            for (;i<len;i++) {
                if (!seg[i]) { continue; }
                s = seg[i].split('=');
                ret[s[0]] = s[1];
            }
            return ret;
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
        hash: a.hash.replace('#',''),
        path: a.pathname.replace(/^([^\/])/,'/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
        segments: a.pathname.replace(/^\//,'').split('/')
    };
}

let user_token = getUrlparam('token');
if(user_token) {
	api.setAuthToken(user_token);
	let urlParseData = parseURL(window.location.hash.substring(1));
	let hash = '#'+urlParseData.path+'?';
	for(var param in urlParseData.params){
		if(param != 'token') {
			hash += param+'='+urlParseData.params[param]+'&'
		}
	}
	window.location = hash;
}

let current_language = getUrlparam('language');
if(current_language){
	localStorage.setItem('WIZARD_MEMBER_LANGUAGE',current_language);
	languages.currentLanguage = current_language;
}



//提示框
Vue.result = Vue.prototype.$result = (message)=>{
	Vue.events.trigger('RESULT-SHOW',message);
}

//events
let events = {};
Vue.events = Vue.prototype.$events = {
	listen:(eventName,callback)=>{
		events[eventName] = callback;
	},
	trigger:(eventName,params)=>{
		if(typeof(events[eventName]) == 'function') {
			events[eventName](params);
		}
	}
}

//提示框
Vue.alert = Vue.prototype.$alert = (message)=>{
	Vue.events.trigger('SHOW-ALERT',message);
}

//国际化
const i18n = new VueI18n({
    locale: languages.currentLanguage, // 语言标识
    messages:languages.lans
})

//基础信息
let games = null;
let payments = null;
let base_configs = null;
Vue.getAppBaseData = Vue.prototype.$getAppBaseData = async (from)=>{
	if(games && payments && base_configs) return {games,payments,base_configs};
	let response =  await api.get('/web/basic/chargeBaseData',{from: from});
	if(response.code == 0){
		games = response.data.games;
		payments = response.data.payments;
		base_configs = response.data.base_configs;
		Vue.games = Vue.prototype.$games = games;
		Vue.baseConfigs = Vue.prototype.$baseConfigs = base_configs;
		
		Vue.events.trigger('APP-BASE-DATA',{games,payments,base_configs});
		return {games,payments,base_configs}
	}
}

Vue.thirdLogin = Vue.prototype.$thirdLogin = (type)=>{
	if(!Vue.baseConfigs || !Vue.baseConfigs.third_login_url) return;
	if(!Vue.baseConfigs.third_login_url[type]) return;
	window.open(Vue.baseConfigs.third_login_url[type],type,"height=650, width=680,toolbar=no, menubar=no, scrollbars=no, resizable=no, location=n o, status=no");
}


//用户信息
let user = null;
Vue.getUser = Vue.prototype.$getUser = async ()=>{
	if(user) return user;
	let response = await api.get('/web/index/getUserBasicInfo');
	if(response.code == 0){
	    user = response.data;
	    api.setAuthToken(response.data.token);
	}else{
		user = null;
	}
	if(user == null){
		window.location = '#/';
	}
	Vue.events.trigger('USER-INFO',user);
	return user;
};

Vue.setUser = Vue.prototype.$setUser = (u)=>{
	if(!user) user = u;
	else{
		if(u){
			user = Object.assign({},user,u);
		}else{
			user = null;
		}
	}
	Vue.events.trigger('USER-INFO',user);
}


window.addEventListener('storage',()=>{//edge浏览器两个标签页localStorage不同步，解决办法
    // console.log("storerage变化了") 
}) 

var vue = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default vue;


